import { memo, useState } from 'react';
import { IconHighlight } from '@aimsos/ui';
import DocumentRichEditor from './DocumentRichEditor.jsx';
import { FileText, X } from 'lucide-react';

const ChatDocumentPanel = ({
  title = 'Document',
  content = '',
  contentFormat = 'auto',
  onContentChange,
  onClose,
  editorKey = 0,
  documentAiEnabled = false,
  isDocumentAiRewriting = false,
  onDocumentAiInstruction,
  onOpenSaveToDrive,
}) => {
  const [headerToolbarHost, setHeaderToolbarHost] = useState(null);

  return (
    <div className="flex h-full max-h-full min-h-0 flex-col overflow-hidden rounded-xl border border-edge bg-surface">
      <div className="flex min-w-0 items-center gap-3 border-b border-edge px-4 py-3">
        <div className="flex min-w-0 flex-1 items-center gap-2">
          <IconHighlight icon={FileText} bgColor="LightBlue" iconColor="Primary" size="small" />
          <h3 className="min-w-0 flex-1 truncate text-sm font-semibold text-content">{title}</h3>
        </div>
        <div
          ref={setHeaderToolbarHost}
          className="flex shrink-0 items-center gap-2"
          aria-label="Document actions"
        />
        <button
          type="button"
          className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-content-secondary transition-colors hover:bg-surface-hover hover:text-content"
          onClick={onClose}
          aria-label="Close document"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
      <div className="scrollbar-aimsos-auto min-h-0 flex-1 overflow-y-auto p-3">
        <DocumentRichEditor
          editorKey={editorKey}
          value={content}
          contentFormat={contentFormat}
          onChange={onContentChange}
          documentTitle={title}
          documentAiEnabled={documentAiEnabled}
          isDocumentAiRewriting={isDocumentAiRewriting}
          onDocumentAiInstruction={onDocumentAiInstruction}
          onOpenSaveToDrive={onOpenSaveToDrive}
          headerToolbarPortalHost={headerToolbarHost}
        />
      </div>
    </div>
  );
};

export default memo(ChatDocumentPanel);
